export const de_DE_globalTranslations = {
  translation: {
    homeSections: {
      howItWorks: {
        title: "Ein paar Klicks und der nächste Werkstatt-Termin ist gebucht",
        note: "* ggf. können zusätzliche Kosten anfallen",
        steps: {
          compare: {
            title: "Werkstätten vergleichen",
            description:
              "Suchen Sie sich die Werkstatt aus, die ideal für Sie ist. Das {{organization}} Werkstattnetz hat für alle Fahrzeuge den richtigen Partner.",
          },
          appointment: {
            title: "Wunschtermin und Zusatzservices aussuchen",
            description:
              "Ganz einfach den passenden Termin aussuchen und auf Wunsch den Hol- und Bringservice* oder einen Ersatzwagen* dazubuchen.",
          },
          arrival: {
            title: "Fahrzeug abholen lassen oder entspannt zur Werkstatt kommen",
            description:
              "Der Termin ist bestätigt und die Werkstatt wartet auf Ihren Besuch oder holt Ihr Fahrzeug, wenn Sie den Zusatzservice Hol- und Bring gebucht haben, direkt bei Ihnen ab.",
          },
          billing: {
            title: "Abrechnung wie gewohnt über {{organization}}",
            description:
              "Nehmen Sie Leistungen bei der Werkstatt in Anspruch, die über die von Ihnen gebuchten Service-Module abgedeckt sind, entsteht für Sie kein weiterer Mehraufwand.",
          },
        },
      },
      benefits: {
        title: "Bestens versorgt mit dem Werkstattnetz von {{organization}}",
        items: {
          partner: {
            title: "{{organization}} Partner",
            description:
              "Alle angezeigten Werkstätten sind {{organization}} Service-Partner und führen alle Inspektions- und Wartungsarbeiten nach Herstellervorgaben durch.",
          },
          originalParts: {
            title: "Ersatzteile in Originalqualität",
            description:
              "{{organization}} Service-Partner arbeiten immer mit Ersatzteilen in Originalqualität.",
          },
          vehicleData: {
            title: "Fahrzeugdaten sind bekannt",
            description:
              "Anhand Ihres Kennzeichens werden die wichtigsten Fahrzeugdaten automatisch durch {{organization}} an den Service-Partner übermittelt.",
          },
          replacementCar: {
            title: "Ersatzwagen und Hol-/Bringservices",
            description:
              "Ein Ersatzwagen oder einen Hol- & Bringservice können Sie bei umfangreicheren Arbeiten bei unseren Service-Partnern dazubuchen. Kosten können ggf. anfallen.",
          },
          manufacturerSpec: {
            title: "Service nach Herstellervorgaben",
            description:
              "Inspektions- und Wartungsarbeiten werden von allen Service-Partnern nach den Vorgaben des Fahrzeugherstellers durchgeführt.",
          },
          oneStop: {
            title: "One-Stop-Shopping",
            description:
              "Bei vielen Service-Partnern können Sie alles auf einmal erledigen lassen: Inspektion, UVV, TÜV, Reifenwechsel, Glasreparatur. Alles in einem Termin.",
          },
          topRated: {
            title: "Top bewertete Werkstätten",
            description:
              "Tausende echte Kundenbewertungen helfen Ihnen, die passende Werkstatt in Ihrer Nähe zu finden.",
          },
        },
      },
    },
    molecules: {
      common: {
        autocomplete: {
          loading: "Nach {{query}} wird gesucht...",
          noResults: "Es tut uns Leid. Für diese Anfrage haben wir keine Ergebnisse gefunden.",
        },
        modals: {
          pickUpAndReturnAddressModal: {
            title: "Standortbestimmung für Hol- & Bring Service",
            description:
              "Bitte geben Sie den Abholort Ihres Fahrzeugs an. Werkstätten, die keinen Hol- & Bring Service für diesen Ort anbieten können, werden automatisch ausgeblendet.",
            submit: "Standort festlegen",
            cancel: "Hol- & Bring Service entfernen",
          },
        },
        dayPicker: {
          loadingState: {
            messages: [
              "Wir verbinden uns mit der Werkstatt…",
              "Kalenderdaten werden geladen…",
              "Terminverfügbarkeit wird abgefragt…",
              "Werkstatt antwortet abwarten…",
              "Synchronisierung läuft…",
              "Kalender wird aktualisiert…",
              "Daten werden geprüft…",
              "Termine werden berechnet…",
            ],
          },
        },
      },
      whitelabel: {
        home: {
          stepper: {
            messageStep: {
              placeholder:
                "Geben Sie hier Ihre Mitteilung ein, die an die Werkstatt weitergeleitet wird.",
              submitButton: {
                label: "weiter",
              },
            },
            contractDataStep: {
              contractNumber: {
                label: "Vertragsnummer",
                placeholder: "1234567",
              },
              numberPlate: {
                label: "Kennzeichen",
              },
              submit: {
                label: "weiter",
              },
            },
          },
        },
        ayvens: {
          rentalCarSelect: {
            categories: {
              label: "Mietwagenkategorie*",
              options: {
                a: "A (z. B. VW Polo, Ford Fiesta)",
                b: "B (z. B. VW Golf, Opel Astra)",
                i: "I (z. B. VW Golf Variant, Ford Focus Turnier)",
              },
            },
            equipments: {
              label: "Mietwagen-Sonderausstattung",
              options: {
                premiumUpliftAutomatic: "Automatik",
                satNavDaily: "Navigation",
              },
            },
          },
        },
      },
    },
    organisms: {
      common: {
        placeSearchInput: {
          geoLocation: {
            loading: "Lade Standortdaten...",
            button: {
              label: "Meinen Standort verwenden",
            },
            errors: {
              lookupFailed: "Ihr Standort konnte nicht über den Browser bestimmt werden.",
            },
          },
        },
      },
    },
    pages: {
      ayvens: {
        pickUpAndReturnObservedRoutes: {
          validation: {
            street: {
              required: "Die Straße darf nicht leer sein.",
            },
            city: {
              required: "Die Stadt darf nicht leer sein.",
            },
            postcode: {
              required: "Die Postleitzahl darf nicht leer sein.",
            },
          },
          noLocationFoundError: "Standort wurde nicht gefunden. Bitte versuchen Sie es erneut.",
          genericError: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
        },
      },
    },
    badges: {
      mobileService: "Mobiler Service",
      smallestDistance: "Geringste Distanz",
      earliestAppointment: "Frühester Termin",
      bestRating: "Beste Bewertung",
      lowestPrice: "Günstigster Preis",
      authorizedGarage: "Herstellerbetrieb",
      recommended: "Empfohlen",
    },
    homeHints: {
      tesla:
        "Bitte setzen Sie sich über die Tesla-App direkt mit einem Tesla-Servicepunkt in Verbindung, um einen Termin zu vereinbaren.",
      MG: "Für die Marke MG gibt es aktuell keine verfügbaren Werkstätten, bitte wenden Sie sich direkt an eine Vertragswerkstatt von MG.",
      searchTestCenter: "Prüfstelle suchen",
      mercedesEV:
        "Für elektrische Fahrzeuge der Marke Mercedes-Benz wenden Sie sich bitte direkt an eine Vertragswerkstatt von Mercedes-Benz.",
      polestar:
        'Für Service und Wartung Ihres Polestars wenden Sie sich direkt an einen autorisierten Service Partner. Eine Übersicht der Polestar Service Points finden Sie <a href="https://www.polestar.com/de/owning-a-polestar/service-points/" title="Polestar Service buchen">hier</a>.',
    },
    contactForm: {
      vinLabel: "Fahrzeug-Identifizierungsnummer (FIN)",
      vinHint:
        "Die FIN steht in der Zulassungsbescheinigung Teil I (Fahrzeugschein Feld 'E') und Teil II (Fahrzeugbrief). Sie existiert auch 'physisch' und meist mehrfach am Fahrzeug selbst etwa an der B-Säule des Türrahmens, also zwischen Vorder- und Hintertür, in der Fahrertür, im Motor- und Kofferraum, unter der Motorhaube oder auf dem Armaturenbrett.",
      vinInvalidHint:
        "Die Buchstaben I, O, Q sind nicht erlaubt. Wahrscheinliche Verwechslung mit den Zahlen 1 oder 0.",
      claimNumber: {
        label: {
          default: "Schadennummer (falls vorhanden)",
          required: "Schadennummer*",
        },
        placeholder: {
          default: "z.B. 12.345.678/TK25/1",
        },
        hint: {
          default:
            "Sofern Ihnen bereits eine Schadennummer im Format 12.345.678/TK25/1 bekannt ist, geben Sie diese bitte an.",
          required:
            "Die Schadennummer finden Sie in der E-Mail über die Sie unseren Online-Service aufgerufen haben.",
        },
      },
    },
    contactFormMessages: {
      activeInquiryExistsForNumberplateErrorMessageTitle: "Sie haben bereits einen Termin",
      activeInquiryExistsForNumberplateAndServiceErrorMessageTitle:
        "Sie haben bereits einen Termin für diesen Service",
      returnDateNotReachedTitle: "Rückgabe ist zu früh geplant",
      returnDateNotReached:
        "Ihr Fahrzeug ist noch nicht für die Rückgabe freigegeben. <br/> Frühestes  Rückgabedatum: {{returnDate}}",
      numberplateCorrect: "Kennzeichen stimmt",
      numberplateChange: "Kennzeichen ändern",
      numberplateNotFoundTitle: "Kennzeichen nicht gefunden",
      numberplateNotFoundMessage:
        "Wir konnten Ihr Fahrzeug nicht im Leasing-Bestand finden. <br/> Bitte prüfen Sie das angegebene Kennzeichen.",
      slotAlreadyTakenTitle: " Oh! Da war jemand schneller",
      nationwideServiceAddressHeadline: "Wo soll der Service durchgeführt werden?",
      wheeSizeDisclaimer:
        "Bitte teilen Sie uns Ihre Reifengröße mit, um Rückfragen von der Werkstatt zu vermeiden.",
      registrationDocumentDisclaimer:
        "Damit die Werkstatt Ihren gewünschten Service umsetzen kann, benötigt diese zeitnah im Vorfeld ein Bild Ihres Fahrzeugscheins. Bitte schicken Sie dieses Bild an werkstattmeister@repareo.de, wir leiten das gerne an die Werkstatt weiter.",
      meinautoContractDoesNotProvideServiceErrorMessageTitle: "Service nicht im Vertrag enthalten",
      meinautoContractDoesNotProvideServiceErrorMessage:
        "Laut ihrem Vertrag haben Sie keine wintertaugliche Bereifung gebucht. Bitte buchen Sie einen anderen Service oder setzten Sie sich mit MeinAuto in Verbindung.",
      customerAddressNotGivenTitle: "Bitte geben sie Ihre Adresse an",
      customerAddressNotGiven:
        "Bei gewissen Services ist die Angabe Ihrer Adresse notwendig. Bitte füllen Sie die entsprechenden Felder aus.",
    },
    bookingInformation: {
      mobileGlassDisclaimer:
        "Der mobile Glasservice fährt direkt zu Ihrer gewünschten Adresse, um Autoscheiben innerhalb von 30 Minuten zu reparieren oder in etwa zwei Stunden auszutauschen und dabei auch komplexe Fahrerassistenzsysteme zu kalibrieren. Der Service ist bundesweit verfügbar.",
    },
    filters: {
      service: "Service: ",
      brand: "Marke: ",
      vehicleType: "Fahrzeugart: ",
      engineType: "Antriebsart: ",
    },
    benefits: {
      feedbackTitle: "Feedback",
    },
    listHints: {
      shownAsNonBookable:
        "Bitte kontaktieren Sie die Werkstatt telefonisch zur Terminvereinbarung, da für den Reifenersatz spezifische Informationen zu den Reifen benötigt werden.",
      availableServicesListItemTitle: "Weitere verfügbare Services",
      leasingVehicleReturn: "Leasingfahrzeug Rückgabe",
      callBacks: "Rückrufaktionen",
      mobileService: " mobiler Vor-Ort-Service",
      glasRepair: "Glasreparatur und Tausch",
      ourTip: "Unsere Auswahl",
      sortedByDistance: "Alle Werkstätten sortiert nach Distanz",
      furtherGaragesSortedByDistance: "Weitere Werkstätten sortiert nach Distanz",
      collectAndReturnTooltip:
        "Hol- & Bringservice bedeutet Ihr Fahrzeug wird geholt und gebracht, sie erhalten keinen Ersatzwagen in der Zeit in der Ihr Fahrzeug in der Werkstatt ist.",
      replacementVehicleTooltip:
        "Zu Ihrem Werkstatttermin steht ein Ersatzwagen bei der Werkstatt zur Verfügung. Sie müssen diesen persönlich vor Ort entgegennehmen und auch wieder bei der Werkstatt zu den Öffnungszeiten abgeben.",
    },
    premiumServices: {
      additionalServices: "Gewünschte Zusatzservices*",
      additionalServicesNoStar: "Gewünschte Zusatzservices",
    },
    generalWords: {
      hint: "Hinweis:",
      back: "Zurück",
    },
    login: {
      title: "Anmeldung",
      subtitle: "Melden Sie sich mit ihrem repareo Account an, um eine Buchung durchzuführen.",
      eMail: "E-Mail",
      password: "Passwort",
      signIn: "Jetzt anmelden",
      validations: {
        email: {
          required: "Bitte geben Sie Ihre E-Mail Addresse an.",
          invalid: "Bitte geben Sie eine gültige E-Mail Addresse an.",
        },
        password: {
          required: "Bitte geben Sie Ihr Passwort an.",
          minLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        },
      },
    },
    vehicleSelector: {
      title: "Für welches Fahrzeug soll gebucht werden?",
      numberPlate: "Kennzeichen",
      searchNumberPlate: "Kennzeichen suchen",
      backToNumberPlateSelection: "Zurück zur Suche",
      isRightVehicle: "Ist dies das richtige Fahrzeug?",
      contractNumber: "Vertragsnummer",
      submit: "Fahrzeug auswählen",
      validation: {
        errors: {
          error: {
            unauthorized: "Sie haben keine Berechtigung.",
            not_found: "Zu diesem Kennzeichen wurde kein Fahrzeug gefunden.",
            vehicle_too_heavy: "Das Fahrzeug ist zu schwer. Das Maximalgewicht beträgt 3500 kg.",
            contract_number_mismatch: "Etwas ist schiefgelaufen.",
            invalid_request: "Etwas ist schiefgelaufen.",
          },
        },
      },
    },
    driverDataStep: {
      mandatory: "Vorgeschriebene Services:",
      optional: "Optionale Services:",
      prohibited: "Nicht verfügbare Services:",
      mandatoryHover: "Diese Services müssen für das Fahrzeug gebucht werden.",
      optionalHover: "Diese Services sind für das Fahrzeug zusätzlich buchbar.",
      prohibitedHover: "Diese Services sind für das Fahrzeug nicht buchbar.",
      backToVehicleSelection: "Zurück zur Fahrzeugauswahl",
    },
    vehicleList: {
      title: "Wählen Sie das Fahrzeug für Ihre Buchung",
      description:
        "Wählen Sie das Kennzeichen, für das Sie eine Buchung vornehmen möchten. Buchungen können für jedes Fahrzeug nacheinander vorgenommen werden.",
      noVehiclesFound:
        "Keine Fahrzeuge gefunden. Bitte prüfen Sie Ihr Kennzeichen oder kontaktieren Sie den Support.",
      errors: {
        invalid_request: "Es gab ein Problem bei der Übertragung der Fahrzeuge zu unserem System.",
      },
    },
    driverDataRoutes: {
      error: {
        title: "Zu Ihrem Kennzeichen ist gerade keine Werkstattbuchung möglich",
        description:
          "Es gab ein Problem bei der Übertragung zwischen MyALD und unserem System. Bitte versuchen Sie es später noch einmal.",
        nextSteps:
          "Sollte es weiterhin nicht funktionieren oder sollten Sie Fragen haben, können Sie uns per Telefon oder E-Mail erreichen unter:",
      },
    },
    pagination: {
      previous: "Vorherige Seite",
      next: "Nächste Seite",
      showing: "Zeige",
      to: "bis",
      of: "von",
      results: "Ergebnissen",
    },
    backToVehicleSelector: {
      restart: "Neu starten",
    },
    vehicleReturn: {
      "identity-headline": "Kundenlogin",
      "identity-text":
        "Bitte identifizieren Sie sich zunächst über die Leasingvertragsnummer, um die Abholung Ihres Fahrzeuges zu beantragen",
      "identity-name": "Kennzeichen",
      "identity-agreement-number": "Leasingvertragsnummer",
      "identity-button": "Zur Abholung",
      "identity-loading": "Leasingvertrag prüfen",
      "identity-error":
        "Wir konnten Ihren Leasingvertrag nicht finden. Bitte überprüfen Sie Ihre Angaben.",
      "summary-headline": "Danke, Abholung beantragt!",
      "summary-text-1":
        "Sie werden in den nächsten Tagen eine Bestätigung Ihres Abholtermins erhalten.",
      "summary-text-2": `Bei Fragen wenden Sie sich bitte per E-Mail an: <a href="mailto:abholung@santander.de">abholung@santander.de</a>`,
      "details-headline": "Abholung",
      "details-address-headline": "Abholadresse",
      "details-date-headline": "Abholdatum",
      "details-email-invalid": "Bitte geben Sie eine gültige E-Mail Adresse ein.",
      "details-modal-headline": "Abholdaten ändern",
      "details-date-text":
        "Bitte geben Sie 3 mögliche Tage an, an denen das Fahrzeug an der oben genannten Adresse abgeholt werden kann. Sie können frühestens einen Termin in 10 Werktagen auswählen.",
      "details-date-1": "Option 1",
      "details-date-2": "Option 2",
      "details-date-3": "Option 3",
      "details-button": "Zur Zusammenfassung",
      "submit-headline": "Zusammenfassung",
      "submit-identity-headline": "Leasingvertragsnummer:",
      "submit-address-headline": "Abholadresse:",
      "submit-email-headline": "E-Mail-Adresse:",
      "submit-date-headline": "Mögliche Abholtermine:",
      "submit-text":
        "Nach dem Klick auf “Abholung beantragen”, erhalten Sie in den nächsten Tagen eine Bestätigung Ihres Abholtermins.<br/><br/>Hiermit bestätige ich verbindlich den o.g.  Wunschort für die Abholung. Eine Änderung zu einem späteren Zeitpunkt ist nicht mehr möglich.",
      "submit-button": "Kostenpflichtige Abholung beantragen",
      "details-cost-accept":
        "Hiermit bestätige ich, dass die Fahrzeugabholung kostenpflichtig ist und akzeptiere die damit verbundenen Kosten gemäß der ausgewiesenen Preisangabe.",
      errors: {
        noData:
          "Vertragsdaten oder Wunsch-Rückgabedaten fehlen. Bitte starten Sie den Prozess von vorne.",
      },
    },
    home: {
      steps: {
        mileage: {
          title: "Geben Sie Ihren Kilometerstand an.",
          submitButton: {
            label: "weiter",
          },
          errors: {
            required: "Bitte geben Sie den Kilometerstand Ihres Fahrzeuges an.",
          },
        },
        message: {
          title: "Ihre Mitteilung an die Werkstatt.",
          completedTitle: "Ihre Mitteilung wurde gespeichert. ",
          backlink: {
            title: "Bearbeiten",
          },
        },
        location: {
          errors: {
            required: "Der Ort ist ein Pflichtfeld.",
          },
        },
        contractData: {
          title: "Geben Sie Ihre Vertragsdaten ein.",
        },
      },
    },
  },
};
